/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { PagedResultDto_ParticipantBroadcastMessageDto } from '../models/PagedResultDto_ParticipantBroadcastMessageDto';
import type { Wealthlane_CustomerService_Dtos_ParticipantBroadcastMessage_CreateParticipantBroadcastMessageDto } from '../models/Wealthlane_CustomerService_Dtos_ParticipantBroadcastMessage_CreateParticipantBroadcastMessageDto';
import type { Wealthlane_CustomerService_Dtos_ParticipantBroadcastMessage_CreateParticipantBroadcastMessageTemplateDto } from '../models/Wealthlane_CustomerService_Dtos_ParticipantBroadcastMessage_CreateParticipantBroadcastMessageTemplateDto';
import type { Wealthlane_CustomerService_Dtos_ParticipantBroadcastMessage_ParticipantBroadcastMessageDto } from '../models/Wealthlane_CustomerService_Dtos_ParticipantBroadcastMessage_ParticipantBroadcastMessageDto';
import type { Wealthlane_CustomerService_Dtos_ParticipantBroadcastMessage_ParticipantBroadcastMessageTemplateDto } from '../models/Wealthlane_CustomerService_Dtos_ParticipantBroadcastMessage_ParticipantBroadcastMessageTemplateDto';
import type { Wealthlane_CustomerService_Dtos_ParticipantBroadcastMessage_UpdateParticipantBroadcastMessageDto } from '../models/Wealthlane_CustomerService_Dtos_ParticipantBroadcastMessage_UpdateParticipantBroadcastMessageDto';
import type { Wealthlane_CustomerService_Dtos_Response_ResponseDto } from '../models/Wealthlane_CustomerService_Dtos_Response_ResponseDto';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class ParticipantBroadcastMessageService {

    /**
     * @param requestBody 
     * @returns Wealthlane_CustomerService_Dtos_Response_ResponseDto OK
     * @throws ApiError
     */
    public static postApiCustomerApiAppParticipantBroadcastMessageParticipantBroadcastMessage(
requestBody?: Wealthlane_CustomerService_Dtos_ParticipantBroadcastMessage_CreateParticipantBroadcastMessageDto,
): CancelablePromise<Wealthlane_CustomerService_Dtos_Response_ResponseDto> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/customer/api/app/participant-broadcast-message/participant-broadcast-message',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param requestBody 
     * @returns Wealthlane_CustomerService_Dtos_Response_ResponseDto OK
     * @throws ApiError
     */
    public static putApiCustomerApiAppParticipantBroadcastMessageParticipantBroadcastMessage(
requestBody?: Wealthlane_CustomerService_Dtos_ParticipantBroadcastMessage_UpdateParticipantBroadcastMessageDto,
): CancelablePromise<Wealthlane_CustomerService_Dtos_Response_ResponseDto> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/customer/api/app/participant-broadcast-message/participant-broadcast-message',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param id 
     * @returns Wealthlane_CustomerService_Dtos_ParticipantBroadcastMessage_ParticipantBroadcastMessageDto OK
     * @throws ApiError
     */
    public static getApiCustomerApiAppParticipantBroadcastMessageParticipantBroadcastMessageById(
id: string,
): CancelablePromise<Wealthlane_CustomerService_Dtos_ParticipantBroadcastMessage_ParticipantBroadcastMessageDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/customer/api/app/participant-broadcast-message/{id}/participant-broadcast-message-by-id',
            path: {
                'id': id,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param filter 
     * @param sorting 
     * @param skipCount 
     * @param maxResultCount 
     * @returns PagedResultDto_ParticipantBroadcastMessageDto OK
     * @throws ApiError
     */
    public static getApiCustomerApiAppParticipantBroadcastMessageParticipantBroadcastMessageList(
filter?: string,
sorting?: string,
skipCount?: number,
maxResultCount?: number,
): CancelablePromise<PagedResultDto_ParticipantBroadcastMessageDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/customer/api/app/participant-broadcast-message/participant-broadcast-message-list',
            query: {
                'Filter': filter,
                'Sorting': sorting,
                'SkipCount': skipCount,
                'MaxResultCount': maxResultCount,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param id 
     * @returns Wealthlane_CustomerService_Dtos_Response_ResponseDto OK
     * @throws ApiError
     */
    public static deleteApiCustomerApiAppParticipantBroadcastMessageParticipantBroadcastMessage(
id: string,
): CancelablePromise<Wealthlane_CustomerService_Dtos_Response_ResponseDto> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/customer/api/app/participant-broadcast-message/{id}/participant-broadcast-message',
            path: {
                'id': id,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @returns Wealthlane_CustomerService_Dtos_ParticipantBroadcastMessage_ParticipantBroadcastMessageTemplateDto OK
     * @throws ApiError
     */
    public static getApiCustomerApiAppParticipantBroadcastMessageParticipantBroadcastMessageTemplates(): CancelablePromise<Array<Wealthlane_CustomerService_Dtos_ParticipantBroadcastMessage_ParticipantBroadcastMessageTemplateDto>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/customer/api/app/participant-broadcast-message/participant-broadcast-message-templates',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param requestBody 
     * @returns Wealthlane_CustomerService_Dtos_Response_ResponseDto OK
     * @throws ApiError
     */
    public static postApiCustomerApiAppParticipantBroadcastMessageParticipantBroadcastMessageTemplate(
requestBody?: Wealthlane_CustomerService_Dtos_ParticipantBroadcastMessage_CreateParticipantBroadcastMessageTemplateDto,
): CancelablePromise<Wealthlane_CustomerService_Dtos_Response_ResponseDto> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/customer/api/app/participant-broadcast-message/participant-broadcast-message-template',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @returns Wealthlane_CustomerService_Dtos_ParticipantBroadcastMessage_ParticipantBroadcastMessageDto OK
     * @throws ApiError
     */
    public static getApiCustomerApiAppParticipantBroadcastMessageParticipantBroadcastMessages(): CancelablePromise<Array<Wealthlane_CustomerService_Dtos_ParticipantBroadcastMessage_ParticipantBroadcastMessageDto>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/customer/api/app/participant-broadcast-message/participant-broadcast-messages',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

}
